import { inject, Injectable } from "@angular/core";
import { ITranslateObject, JobsBillingCard } from "../views-interfaces";
import { MultiSelectModel, Option } from "@app/filter-menu/filter-types";
import { JobsAndBillingJobTypesService } from "@app/shared/jobs-and-billing-job-types-service/jobs-and-billing-job-types.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class JobsTypeFilterGeneratorService {
    private readonly jobsAndBillingJobTypesService = inject(JobsAndBillingJobTypesService);
    private readonly translateService = inject(TranslateService);
    
    constructor() {}

    async generateModel(selection: Option[]) {
        const jobTypes = await this.jobsAndBillingJobTypesService.getJobTypes();

        const options: Option[] = jobTypes.filter((option) => option.active).map((option) => ({
            text: {
                "en-CA": option.name["en-CA"].trim(),
                "fr-CA": option.name["fr-CA"].trim(),
            } as ITranslateObject,
            value: option.id.toString()
            })).sort((a, b) => {
            const textA = (typeof a.text === "string" ? a.text : a.text[this.translateService.getCurrentLang()] || a.text[this.translateService.getFallbackLang()]).toLowerCase();
            const textB = (typeof b.text === "string" ? b.text : b.text[this.translateService.getCurrentLang()] || b.text[this.translateService.getFallbackLang()]).toLowerCase();
            return textA.localeCompare(textB);
            });


        return {
            label: {
                "en-CA": 'Job Type',
                "fr-CA": 'Type de mandat',
            } as ITranslateObject,
            applicableOptions: options,
            allOptions: options,
            selection: selection.filter((selected) => options.some((applicable) => selected.value === applicable.value)),
        } as MultiSelectModel;
    }

    getPrintDescription(
        label: string | ITranslateObject,
        selectedOptions: Option[],
    ): { label: string | ITranslateObject; values: (string | ITranslateObject)[] } | null {
        if (!selectedOptions || selectedOptions.length === 0) {
            return null;
        } else {
            return {
                label,
                values: selectedOptions.map((value) => {
                    return value.text;
                }),
            };
        }
    }

    async generateFilter(selectedValues: string[]) {
        if (!selectedValues || selectedValues.length === 0) {
            return null;
        } else {
            return (card: JobsBillingCard) => {
                const type = card.job.typeId?.toString();
                return selectedValues.includes(type) || (type == null && selectedValues.includes("-1"));
            };
        }
    }
}
